<template>
  <ankh-list :padding="0" :show-btn-group="!isPlain" v-bind="$attrs">
    <template #search-form>
      <el-form-item :label="$t('温度')">
        <el-input :placeholder="$t('温度')" clearable v-model="searchForm.temperature" />
      </el-form-item>
      <el-form-item :label="$t('协议代码')">
        <el-input :placeholder="$t('协议代码')" clearable v-model="searchForm.protocolCode" />
      </el-form-item>
      <el-form-item :label="$t('创建日期')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button size="small" type="primary" @click="$emit('export')">{{$t('导出')}}</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          :search-params="searchForm"
          @query="loadList"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="$t('温度')" prop="temperature">
          <template v-slot="{row}">
            {{row.temperature || 0}} °C
          </template>
        </el-table-column>
        <el-table-column :label="$t('协议代码')">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" id="copyBtn" :data-clipboard-text="row.protocolCode" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('创建日期')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column :label="$t('操作')" v-if="!isPlain">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <!-- 新增/编辑-->
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleReset">
        <template #title>
          <h4>{{ isEdit ? "编辑" : "新增" }}</h4>
        </template>

        <el-form label-width="auto" ref="form" :rules="rules" :model="formData">
          <el-form-item :label="$t('温度')" prop="temperature">
            <el-input :placeholder="$t('温度')" v-model="formData.temperature">
              <template #append>°C</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('协议')" prop="protocolCode">
            <div class="flex gap-6">
              <el-input :placeholder="$t('协议')" v-model="formData.protocolCode" />
<!--              <el-button type="primary" size="small" @click="buildProtocol">生成协议</el-button>-->
            </div>
          </el-form-item>
          <el-form-item :label="$t('备注')" prop="remark">
            <el-input :placeholder="$t('备注')" type="textarea" :rows="4" v-model="formData.remark" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleAddOrEditSubmit">{{$t('删除')}}</el-button>
          <el-button @click="handleReset">{{$t('确定')}}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import {copyText} from "@/utils/copy";
import {getProtocol} from "@/utils/protocol";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "Temperature",
  components: {AnkhList, DateTimeRangePicker, TableList},
  props: {
    isPlain: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableData: [],
      searchForm: {},
      selection: [],
      showDialog: false,
      formData: {
        temperature: null,
        protocolCode: null,
        remark: null,
      },
      rules: {
        temperature: [
          {required: true, message: this.$t('请输入温度'), trigger: 'blur'},
          {pattern: /^[1-9]\d*$/, message: this.$t('请输入大于0的整数'), trigger: 'blur'}
        ],
        protocolCode: {required: true, message: this.$t('协议不能为空'), trigger: 'blur'},
      },
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 导出
    handleExport() {
      const codes = this.selection.map(item => item.code);
      exportExcel(codes, this.$api.common.exportTemperatureSet);
    },

    // 构建协议
    buildProtocol() {
      try {
        const val = this.formData.temperature;
        if(!val || isNaN(Number(val))) {
          this.$message.error(this.$t('请输入正确的温度'));
          return;
        }
        const prefix = "ee150100"
        this.formData.protocolCode = getProtocol(prefix, Number(val), 1);
      } catch (e) {
        console.error("生成协议失败", e);
      }
    },

    // 复制
    handleCopy() {
      copyText("#copyBtn");
    },

    // 新增\编辑
    handleAddOrEditSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          let data = {...this.formData};
          const action = this.$api.temperatureSet[this.isEdit ? 'update' : 'add'];
          if(this.isEdit) {
            data = Object.assign(this.currentRow, data);
            delete data.createTime;
            delete data.updateTime;
          }
          await request(action, data);
          this.$message.success(this.$t('操作成功'));
          this.showDialog = false;
          this.$refs.list.handleRequest();
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 重置
    handleReset() {
      this.$refs.form.resetFields();
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        for (const key in this.formData) {
          this.formData[key] = row[key];
        }
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleBatchDelete() {
      try {
        const codes = this.selection.map(i => i.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(this.$api.temperatureSet.batchDelete, codes, {isJson: true}, {message: this.$t('您现在正在进行批量删除操作, 是否继续?')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.temperatureSet.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.temperatureSet.list, params);
        this.tableData = res.temperatureSets;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    selection: {
      handler(list) {
        const codes = list.map(i => i.code);
        this.$emit("select", {temperatureSetCodes: codes});
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
